import fetchHandler, { fetchHandlerForm } from '../Handler';

export const MeGet = async (endpoint?: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: endpoint,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
export const MePUtBAsic = async (endpoint?: any, body?: any): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PUT',
			endpoint: endpoint,
			body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
export const MePUTADDress = async (endpoint?: any, data?: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'PUT',
			endpoint: endpoint,
			data,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
export const MePUTKYC = async (endpoint?: any, data?: any): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PUT',
			endpoint: endpoint,
			body: data,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};
